// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jkHTJMvPV6zoEq {\n  color: var(--ds-text-subtle, #5E6C84);\n  display: block;\n  font-size: 12px;\n  line-height: 10px;\n  margin: 0;\n  padding: 0;\n}\n.KAfuUh789DlsJ7 {\n  font-size: 12px;\n  padding: 0;\n  margin: 0;\n  color: var(--ds-text-subtle, #5E6C84);\n  text-decoration: underline;\n  background-color: transparent;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "jkHTJMvPV6zoEq",
	"upgradeButton": "KAfuUh789DlsJ7"
};
export default ___CSS_LOADER_EXPORT___;
